export default __webpack_public_path__ + "static/0243-eb9a1f6e8d2c7ffa9d5e3e975cebd4f7.png";